import { Link } from "react-router-dom";
import { Sparkles, ShieldCheck, Heart, Leaf } from "lucide-react";
import { site } from "@/config/site";
import { Seo } from "@/components/Seo";
import { LocalBusinessJsonLd } from "@/components/LocalBusinessJsonLd";
import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { MapSection } from "@/components/MapSection";
import { CtaBlock } from "@/components/CtaBlock";

const values = [
  { icon: Sparkles, title: "Özen", text: "Her seans, misafirimizin ihtiyacı dinlenerek başlar ve ona göre şekillenir." },
  { icon: ShieldCheck, title: "Hijyen", text: "Her misafir için değiştirilen tekstiller ve seans öncesi temizlenen odalar." },
  { icon: Heart, title: "Mahremiyet", text: "Sakin, kapalı ve saygılı bir ortamda kendinizi güvende hissedersiniz." },
  { icon: Leaf, title: "Sadelik", text: "Gösterişli vaatler yok; temiz bir ortam ve gerçekten dinlendiren bir deneyim var." },
];

export default function About() {
  return (
    <>
      <Seo
        title="Hakkımızda | Lavenza Masaj Salonu Bursa Nilüfer"
        description="Lavenza Masaj Salonu, Bursa Nilüfer Konak Mahallesi'nde klasik, medikal, soft masaj ve kese köpük hizmeti veren butik bir masaj salonudur. Hijyen, özen ve sakinlik."
        path="/hakkimizda"
      />
      <LocalBusinessJsonLd />
      <PageHero
        eyebrow="Hakkımızda"
        accent="Lavenza"
        title="Masaj Salonu Bursa"
        text="Nilüfer Konak Mahallesi'nde, sadeliği ve özeni merkeze alan butik bir masaj salonu."
        crumbs={[{ label: "Ana Sayfa", path: "/" }, { label: "Hakkımızda", path: "/hakkimizda" }]}
        testId="about-hero"
      />
      <section className="section bg-white" data-testid="about-story">
        <div className="container-wide grid gap-10 lg:grid-cols-2 lg:items-center">
          <img src="/images/bursa-medikal-masaj.webp" alt="Lavenza uygulama odası" width="1200" height="800" loading="lazy" className="rounded-2xl shadow-xl aspect-[3/2] object-cover" />
          <div>
            <span className="eyebrow mb-3">Hikayemiz</span>
            <h2 className="section-title"><span className="text-emerald">Sakin</span> Bir Mola İçin</h2>
            <div className="section-divider my-5 mx-0" />
            <div className="space-y-4 text-muted leading-relaxed">
              <p>Lavenza, Bursa Nilüfer'in Konak Mahallesi'nde, Kurşunlu Sokak üzerinde hizmet veren bir masaj salonudur. Günlük hayatın temposunda biriken yorgunluğu geride bırakmak isteyen misafirlerimize klasik, medikal ve soft masaj ile kese & köpük uygulamaları sunuyoruz.</p>
              <p>Bizim için iyi bir masaj deneyimi üç şeye dayanır: dinlemek, özen göstermek ve temiz bir ortam sunmak. Bu nedenle her seans öncesinde kısa bir görüşme yapar, tercihlerinizi öğrenir ve uygulamayı size göre planlarız.</p>
              <p>Fiyat ve süre bilgisi için WhatsApp'tan yazmanız yeterlidir; size en kısa sürede dönüş yaparız.</p>
            </div>
            <Link to="/masaj-hizmetleri" className="btn btn-emerald mt-8" data-testid="about-services-link">Hizmetlerimizi İnceleyin</Link>
          </div>
        </div>
      </section>
      <section className="section bg-offwhite" aria-labelledby="degerler-title" data-testid="about-values">
        <div className="container-wide">
          <SectionHeading eyebrow="Değerlerimiz" accent="Lavenza" title="İlkeleri" id="degerler-title" />
          <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {values.map(({ icon: Icon, title, text }) => (
              <li key={title} className="card p-6 hover-lift">
                <div className="icon-box mb-5"><Icon className="w-7 h-7" aria-hidden="true" /></div>
                <h3 className="font-bold text-lg mb-2">{title}</h3>
                <p className="text-sm text-muted leading-relaxed">{text}</p>
              </li>
            ))}
          </ul>
          <p className="mt-10 text-center text-sm text-muted">{site.openingHours.text} · {site.address.full}</p>
        </div>
      </section>
      <MapSection />
      <CtaBlock />
    </>
  );
}
